import { render, staticRenderFns } from "./GenviteConflictDetails.vue?vue&type=template&id=1a0b30f1&scoped=true&"
import script from "./GenviteConflictDetails.vue?vue&type=script&lang=js&"
export * from "./GenviteConflictDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b30f1",
  null
  
)

export default component.exports